<script setup>
import { getI18n } from '@/plugins/i18n'
import { usePortalStore } from '@/stores/portal.store'

const props = defineProps({
  modelValue: {
    type: String,
    default: null,
  },
  readonly: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['update:modelValue'])

const i18n = getI18n()
const portalStore = usePortalStore()
</script>

<template>
  <q-select
    :model-value="props.modelValue || portalStore.selectedLanguage"
    :label="i18n.t('common.documentLanguage')"
    :options="portalStore.getLocalizedLanguages()"
    option-value="code"
    option-label="name"
    emit-value
    map-options
    :readonly="props.readonly"
    @update:model-value="value => emit('update:modelValue', value)"
  />
</template>
